import React from "react";

const useCases = [
  { emoji: "🏢", title: "Housing Societies", desc: "Festivals, Annual Meetings, Sports Days, Cultural Events and Community Celebrations." },
  { emoji: "🏬", title: "Commercial Complexes", desc: "Tenant Engagement, Business Meets, Product Launches and Employee Activities." },
  { emoji: "🏢", title: "Corporate Events", desc: "Town Halls, Team Building, Annual Functions, Training Programs and Conferences." },
  { emoji: "🎂", title: "Birthdays", desc: "Make birthday celebrations more interactive with fun quizzes and games." },
  { emoji: "💍", title: "Anniversaries", desc: "Celebrate memorable milestones with family and friends through live participation." },
  { emoji: "🏫", title: "Schools", desc: "Assemblies, Annual Days, Parent Meetings, Competitions and Celebrations." },
  { emoji: "🎓", title: "Colleges & Universities", desc: "Freshers, Farewells, Fests, Alumni Meets and Youth Festivals." },
  { emoji: "📚", title: "Coaching Institutes", desc: "Knowledge Challenges, Student Engagement and Reward Programs." },
  { emoji: "👨‍👩‍👧‍👦", title: "Family Reunions", desc: "Bring generations together with memories, fun and friendly competition." },
  { emoji: "🫂", title: "Friends Reunion", desc: "Reconnect with old friends through exciting live quizzes and challenges." },
  { emoji: "🙏", title: "Religious Events", desc: "Community gatherings, festivals, awareness drives and spiritual celebrations." },
  { emoji: "🎊", title: "Community Festivals", desc: "Ganesh Utsav, Durga Puja, Navratri, Christmas, Eid and local celebrations." },
  { emoji: "🏆", title: "Prize Ceremonies", desc: "Create excitement while announcing finalists and winners live." },
  { emoji: "⚽", title: "Sports & Playgrounds", desc: "Sports quizzes, fan engagement and live audience participation." },
  { emoji: "🌍", title: "NGOs & Public Events", desc: "Awareness campaigns, volunteer engagement and social initiatives." },
  { emoji: "✨", title: "And Much More...", desc: "Anywhere people gather, Reunion can make the occasion more engaging." },
];

const ReunionUseCases = () => {
  return (
    <section className="relative py-20 px-6 bg-gradient-to-b from-[#04110e] via-[#071714] to-[#081311]">

      <div className="max-w-7xl mx-auto">

        {/* Heading */}
        <div className="text-center mb-4">

          <div className="inline-flex items-center gap-2 px-5 py-2 rounded-full bg-emerald-500/10 border border-emerald-400/20 mb-5">
            <span className="text-xl">🌍</span>
            <span className="uppercase tracking-[0.3em] text-xs font-semibold text-emerald-300">
              Where Reunion Works
            </span>
          </div>

          <h2 className="text-3xl lg:text-5xl font-black text-white mb-5">
            One Platform.
            <br />
            Every Occasion.
          </h2>

          <p className="max-w-3xl mx-auto text-emerald-100/80 text-sm lg:text-lg leading-relaxed">
            Reunion is designed for every celebration, gathering, event and
            community where people come together to connect, participate and
            create unforgettable memories.
          </p>

        </div>

        {/* Cards */}
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">

          {useCases.map((item, index) => (
            <div
              key={index}
              className="rounded-3xl bg-white/5 border border-white/10 backdrop-blur-md p-6 hover:border-emerald-400/40 hover:bg-emerald-500/10 transition-all duration-300 hover:-translate-y-2"
            >
              <div className="text-5xl mb-5">
                {item.emoji}
              </div>

              <h3 className="text-lg font-bold text-white mb-3">
                {item.title}
              </h3>

              <p className="text-sm text-emerald-100/80 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}

        </div>

        {/* Bottom Banner */}
        <div className="mt-16 rounded-3xl border border-emerald-500/20 bg-gradient-to-r from-emerald-500/10 via-teal-500/10 to-purple-500/10 p-8 text-center">

          <div className="text-5xl mb-4">🎉</div>

          <h3 className="text-2xl lg:text-3xl font-black text-white mb-4">
            If People Are Gathering...
            <br />
            Reunion Belongs There.
          </h3>

          <p className="max-w-4xl mx-auto text-emerald-100/80 text-sm lg:text-lg leading-relaxed">
            From small family celebrations to large community festivals and
            corporate events, Reunion transforms ordinary gatherings into
            exciting, interactive and memorable experiences for everyone.
          </p>

        </div>

      </div>

    </section>
  );
};

export default ReunionUseCases;